/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Contact_TitleInputs */

const cs_public_site_contact_title = /** @type {(inputs: Public_Site_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máte zájem? Napište nám`)
};

const en_public_site_contact_title = /** @type {(inputs: Public_Site_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interested? Get in touch`)
};

/**
* | output |
* | --- |
* | "Interested? Get in touch" |
*
* @param {Public_Site_Contact_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_contact_title = /** @type {((inputs?: Public_Site_Contact_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Contact_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_contact_title(inputs)
	return cs_public_site_contact_title(inputs)
});